import { render, staticRenderFns } from "./AFWithdrawManagementScreen.vue?vue&type=template&id=7c7946e2&scoped=true&"
import script from "./AFWithdrawManagementScreen.vue?vue&type=script&lang=js&"
export * from "./AFWithdrawManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7946e2",
  null
  
)

export default component.exports